@use '../../scss/global' as *;
@use '../../scss/components/form-element.mixins' as *;
@use 'themes';

// ================================================================ //
// -- Local Variables

// ================================================================ //
// -- Component Styles

:host {
  display: block;

  .fluid-input-field {

    // ==== Shared Form Element Styles

    @include form-group();
    @include form-container();
    @include form-element-placeholder();
    @include form-element-stepper-buttons();
    @include form-element-cancel-button();
    @include focus-indicator();
    @include form-element-adornment();

    // ==== Form Container

    .form-container {
      padding-top: var(--form-element-padding-top); // Generated by form-element-padding-vars()
      padding-bottom: var(--form-element-padding-bottom); // Generated by form-element-padding-vars()
    }

    // ==== Input Element

    .input-field-input {
      @include input-reset;
      width: 100%;
    }
  }
}
